var render, staticRenderFns
import script from "./dict.table.vue?vue&type=script&lang=js"
export * from "./dict.table.vue?vue&type=script&lang=js"
import style0 from "./dict.table.vue?vue&type=style&index=0&id=01fb907e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fb907e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01fb907e')) {
      api.createRecord('01fb907e', component.options)
    } else {
      api.reload('01fb907e', component.options)
    }
    
  }
}
component.options.__file = "found/views/mdm/views/dict/dict_detail/dict.table.vue"
export default component.exports